module.exports = __webpack_public_path__ + "static/media/Speedup.53b55fa1.svg";